import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Reveal } from "@/components/Reveal";

export default function CmsBanner({ content = {} }) {
  const { eyebrow, heading, subtext, image_url, video_url, cta_label, cta_href } = content;
  return (
    <section data-testid="cms-banner" className="mx-auto max-w-7xl px-4 py-5 sm:px-6">
      <Reveal>
        <div className="relative overflow-hidden rounded-3xl border border-champagne/40">
          {video_url ? (
            <video autoPlay muted loop playsInline poster={image_url || undefined} className="h-[320px] w-full object-cover sm:h-[420px]">
              <source src={video_url} type={video_url.endsWith(".webm") ? "video/webm" : "video/mp4"} />
            </video>
          ) : (
            image_url && <img src={image_url} alt={heading || "Soonyoung"} className="h-[320px] w-full object-cover sm:h-[420px]" />
          )}
          <div className="absolute inset-0 bg-gradient-to-t from-white/85 via-white/20 to-transparent" />
          <div className="absolute bottom-0 left-0 p-6 sm:p-10">
            {eyebrow && <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-gold">{eyebrow}</p>}
            {heading && <h2 className="mt-2 max-w-lg font-display text-3xl tracking-tight text-cream sm:text-5xl">{heading}</h2>}
            {subtext && <p className="mt-2 max-w-md text-sm text-sage">{subtext}</p>}
            {cta_label && cta_href && (
              <Link to={cta_href} data-testid="cms-banner-cta" className="mt-5 inline-flex items-center gap-2 rounded-full bg-gold px-7 py-3.5 text-xs font-bold uppercase tracking-[0.2em] text-forest transition-transform hover:scale-105">
                {cta_label} <ArrowRight className="h-4 w-4" />
              </Link>
            )}
          </div>
        </div>
      </Reveal>
    </section>
  );
}
